module.exports = __webpack_public_path__ + "fonts/productSans.eb11bfb3.woff2";